var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Projects")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"ident":"vue-loader-options"}!./node_modules/vue-loader/lib?{"ident":"vue-loader-options"}!./src/Views/Projects.vue?vue&type=template&id=3004d9b9
// module id = 206
// module chunks = 0